import styled from "styled-components";

export const AddToCartWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 1.5rem;
`;
